<template>
  <div>
    <tableComponent
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      :enable-row-clickable="true"
      @newDocument="newDocument"
      @clickedRow="openStorageLocation($event)"
      @openMultiUserDialog="openMultiUserDialog"
      @openExport="openExport"
    />
    <dangerous-good-export-dialog
      ref="exportDialog"
      mode="locations"
      :storage-locations="transferItems"
    />
    <multiUserDialog
      v-model="multiUserOpen"
      entityType="dangerousGoodStorageLocation"
      :availableItems="transferItems"
      itemText="name"
      itemValue="_id"
      :clients="transferClients"
      :currentClientId="currentClientId"
      @confirm="executeTransfer"
      entityLabel="multiUser.dialog.storageLocations"
    />
  </div>
</template>
<script>
import { getUniqueId } from "../../components/api/api";
import tableComponent from "../../components/_utils/dataTableHelpers/tableComponent.vue";
import multiUserDialog from "../../components/_utils/dataTableHelpers/actions/multiUserDialog.vue";
import DangerousGoodExportDialog from "@/components/dangerousGoods/DangerousGoodExportDialog.vue";

export default {
  components: {
    tableComponent,
    multiUserDialog,
    DangerousGoodExportDialog,
  },
  data: () => ({
    tableSettings: {
      title: "",
      showSelect: false,
      showHeaderToolbar: true,
      headerButtons: [
        {
          title: "multiUser.button",
          color: "primary",
          action: "openMultiUserDialog",
          icon: "mdi-swap-horizontal",
          iconDark: true,
          dark: true,
        },
        {
          title: "dangerousGoods.dangerousGoodsList.export.button",
          color: "primary",
          action: "openExport",
          icon: "mdi-file-excel-outline",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "dangerousGoods.storageLocation.new",
          color: "secondary",
          action: "newDocument",
          icon: "add",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
      multipleSelectButtons: [],
    },
    counts: {},
    currentClientId: "",
    isMultiUser: false,
    multiUserOpen: false,
    transferClients: [],
    transferItems: [],
  }),
  async created() {
    const user = await this.$store.dispatch("getUserInfo");
    this.currentClientId = user?.client?._id || "";
    this.isMultiUser = user?.role === "MultiUser";

    const res = await this.$store.dispatch(
      "getAllDangerousGoodsStorageLocations"
    );
    this.transferItems = res.data || res;

    this.fetchCounts();

    if (!this.isMultiUser) {
      this.tableSettings.headerButtons =
        this.tableSettings.headerButtons.filter(
          (btn) => btn.action !== "openMultiUserDialog"
        );
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("dangerousGoods.storageLocation.tableHeader.name"),
          value: "name",
          align: "left",
        },
        {
          text: this.$t("folderCount.total"),
          value: "folderTotal",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "storageLocationAction",
          align: "right",
          sortable: false,
        },
      ];
    },
    tableData() {
      return {
        tableComponentSlots: [
          {
            id: getUniqueId(),
            slotName: "item.folderTotal",
            componentName: "folderCount",
            config: { kind: "total", counts: this.counts },
          },
          {
            id: getUniqueId(),
            slotName: "item.storageLocationAction",
            componentName: "storageLocationAction",
          },
        ],
        itemKey: "id",
        uriPartPrepend: "dangerousGoodStorageLocation",
        uriPartAppend: "",
        populate: [],
        sort: "-createdAt",
        editFormPushName: "dangerousGoodsStorageLocationForm",
        detailViewPushName: "dangerousGoodsList",
      };
    },
  },
  methods: {
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
      this.fetchCounts();
    },
    async fetchCounts() {
      this.counts =
        (await this.$store.dispatch(
          "getDangerousGoodsStorageLocationCounts"
        )) || {};
    },
    newDocument() {
      this.$router.push({
        name: this.tableData.editFormPushName,
        params: { id: "1", mode: "new", data: 1 },
      });
    },
    openExport() {
      this.$refs.exportDialog.open();
    },
    openStorageLocation(event) {
      this.$router.push({
        name: this.tableData.detailViewPushName,
        params: {
          storageLocationId: event.id,
          storageLocationName: event.name,
        },
      });
    },

    async openMultiUserDialog() {
      try {
        const res = await this.$store.dispatch("getTransferClients");
        this.transferClients = res.data || [];
      } catch (e) {
        return;
      }
      this.multiUserOpen = true;
    },

    async executeTransfer(payload) {
      try {
        const result = await this.$store.dispatch("transferEntities", payload);

        const parts = [];
        if (result.totalSuccess > 0) {
          parts.push(
            this.$t("multiUser.result.success", {
              number: result.totalSuccess,
            })
          );
        }
        if (result.totalConflict > 0) {
          parts.push(
            this.$t("multiUser.result.error", {
              number: result.totalConflict,
            })
          );
        }
        if (result.totalError > 0) {
          parts.push(
            this.$t("multiUser.result.error", { number: result.totalError })
          );
        }

        this.$store.commit("CREATE_SNACKBAR", parts.join(" · "));

        if (payload.action === "move" && result.totalSuccess > 0) {
          this.reloadDataFunc();
        }
      } catch (e) {
        console.error("Transfer failed:", e);
      }
    },
  },
};
</script>
